export enum NucleotidesUIActionType {
  HOVER_MONOMERS = 'HOVER_MONOMERS',
  HOVER_NUCLEOTIDE_IDX = 'HOVER_NUCLEOTIDE_IDX',
  SELECT_NUCLEOTIDE_ROWS = 'SELECT_NUCLEOTIDE_ROWS',
  DESELECT_NUCLEOTIDE_ROWS = 'DESELECT_NUCLEOTIDE_ROWS',
  CLEAR_NUCLEOTIDE_ROW_SELECTION = 'CLEAR_NUCLEOTIDE_ROW_SELECTION',
  EDIT_NUCLEOTIDE_INDICES = 'EDIT_NUCLEOTIDE_INDICES',
  FINISH_EDITING_NUCLEOTIDE_INDEX = 'FINISH_EDITING_NUCLEOTIDE_INDEX',
  OPEN_SEQUENCE = 'OPEN_SEQUENCE',
  CLOSE_SEQUENCE = 'CLOSE_SEQUENCE',
  UPDATE_TABLE_PAGINATION_OFFSET = 'UPDATE_TABLE_PAGINATION_OFFSET',
  PAGE_NUCLEOTIDE_ROW_INTO_VIEW = 'PAGE_NUCLEOTIDE_ROW_INTO_VIEW',
}

interface HoverMonomersAction {
  type: NucleotidesUIActionType.HOVER_MONOMERS;
  monomerIds: Array<string | null>;
  sequenceId: string;
}
export function hoverMonomers(sequenceId: string, monomerIds: Array<string | null>): HoverMonomersAction {
  return {
    type: NucleotidesUIActionType.HOVER_MONOMERS,
    monomerIds,
    sequenceId,
  };
}

interface HoverNucleotideIdxAction {
  type: NucleotidesUIActionType.HOVER_NUCLEOTIDE_IDX;
  nucleotideIdx: number | null;
  sequenceId: string;
}
export function hoverNucleotideIdx(
  sequenceId: string,
  nucleotideIdx: number | null
): HoverNucleotideIdxAction {
  return {
    type: NucleotidesUIActionType.HOVER_NUCLEOTIDE_IDX,
    nucleotideIdx,
    sequenceId,
  };
}

interface EditNucleotideIndicesAction {
  type: NucleotidesUIActionType.EDIT_NUCLEOTIDE_INDICES;
  nucleotideIndices: Array<number>;
  sequenceId: string;
}
export function editNucleotideIndices(
  sequenceId: string,
  nucleotideIndices: Array<number>
): EditNucleotideIndicesAction {
  return {
    type: NucleotidesUIActionType.EDIT_NUCLEOTIDE_INDICES,
    nucleotideIndices,
    sequenceId,
  };
}

interface FinishEditingNucleotideIndicesAction {
  type: NucleotidesUIActionType.FINISH_EDITING_NUCLEOTIDE_INDEX;
  nucleotideIdx: number;
  sequenceId: string;
}
export function finishEditingNucleotideIndex(
  sequenceId: string,
  nucleotideIdx: number
): FinishEditingNucleotideIndicesAction {
  return {
    type: NucleotidesUIActionType.FINISH_EDITING_NUCLEOTIDE_INDEX,
    nucleotideIdx,
    sequenceId,
  };
}

interface OpenSequenceAction {
  type: NucleotidesUIActionType.OPEN_SEQUENCE;
  sequenceId: string;
}
export function openSequence(sequenceId: string): OpenSequenceAction {
  return {
    type: NucleotidesUIActionType.OPEN_SEQUENCE,
    sequenceId,
  };
}

interface CloseSequenceAction {
  type: NucleotidesUIActionType.CLOSE_SEQUENCE;
  sequenceId: string;
}
export function closeSequence(sequenceId: string): CloseSequenceAction {
  return {
    type: NucleotidesUIActionType.CLOSE_SEQUENCE,
    sequenceId,
  };
}

interface SelectNucleotideRowsAction {
  type: NucleotidesUIActionType.SELECT_NUCLEOTIDE_ROWS;
  sequenceId: string;
  positions: Array<number>;
}
export function selectNucleotideRows(
  sequenceId: string,
  positions: Array<number>
): SelectNucleotideRowsAction {
  return {
    type: NucleotidesUIActionType.SELECT_NUCLEOTIDE_ROWS,
    sequenceId,
    positions,
  };
}

interface DeselectNucleotideRowsAction {
  type: NucleotidesUIActionType.DESELECT_NUCLEOTIDE_ROWS;
  sequenceId: string;
  positions: Array<number>;
}
export function deselectNucleotideRows(
  sequenceId: string,
  positions: Array<number>
): DeselectNucleotideRowsAction {
  return {
    type: NucleotidesUIActionType.DESELECT_NUCLEOTIDE_ROWS,
    sequenceId,
    positions,
  };
}

interface ClearNucleotideRowSelectionAction {
  type: NucleotidesUIActionType.CLEAR_NUCLEOTIDE_ROW_SELECTION;
  sequenceId: string;
}
export function clearNucleotideRowSelection(sequenceId: string): ClearNucleotideRowSelectionAction {
  return {
    type: NucleotidesUIActionType.CLEAR_NUCLEOTIDE_ROW_SELECTION,
    sequenceId,
  };
}

interface UpdateNucleotidesTablePaginationOffsetAction {
  type: NucleotidesUIActionType.UPDATE_TABLE_PAGINATION_OFFSET;
  sequenceId: string;
  offset: number;
}
export function updateNucleotidesTablePaginationOffset(
  sequenceId: string,
  offset: number
): UpdateNucleotidesTablePaginationOffsetAction {
  return {
    type: NucleotidesUIActionType.UPDATE_TABLE_PAGINATION_OFFSET,
    sequenceId,
    offset,
  };
}

interface PageNucleotideRowIntoViewAction {
  type: NucleotidesUIActionType.PAGE_NUCLEOTIDE_ROW_INTO_VIEW;
  sequenceId: string;
  position: number;
}
export function pageNucleotideRowIntoView(
  sequenceId: string,
  position: number
): PageNucleotideRowIntoViewAction {
  return {
    type: NucleotidesUIActionType.PAGE_NUCLEOTIDE_ROW_INTO_VIEW,
    sequenceId,
    position,
  };
}
export type ModifiedNucleotidesUIAction =
  | HoverMonomersAction
  | HoverNucleotideIdxAction
  | EditNucleotideIndicesAction
  | FinishEditingNucleotideIndicesAction
  | OpenSequenceAction
  | CloseSequenceAction
  | SelectNucleotideRowsAction
  | DeselectNucleotideRowsAction
  | ClearNucleotideRowSelectionAction
  | UpdateNucleotidesTablePaginationOffsetAction
  | PageNucleotideRowIntoViewAction;
